// Warmth on a skin, per vertex of the rest mesh: 0 cold, 1 as warm as a hand.
// A finger warms the spot under it, warmth spreads to the skin around it, and
// everything slowly leaks back to the cold air.
export class WarmthField{
  // radius: size of the toy; spread: how fast warmth moves along the skin;
  // cool: share lost to the air per second.
  constructor(rest,{radius,spread=25,cool=.055}={}){
    this.rest=rest;this.radius=radius;this.spread=spread;this.cool=cool;
    const n=rest.length/3;this.warmth=new Float32Array(n);this.scratch=new Float32Array(n);
    // Neighbours: skin points within a small reach, from a spatial hash.
    const reach=radius*.13,cell=reach,grid=new Map(),key=(x,y,z)=>`${x},${y},${z}`;
    for(let i=0;i<n;i++){const k=key(Math.floor(rest[i*3]/cell),Math.floor(rest[i*3+1]/cell),Math.floor(rest[i*3+2]/cell));if(!grid.has(k))grid.set(k,[]);grid.get(k).push(i);}
    const lists=[];
    for(let i=0;i<n;i++){
      const x=rest[i*3],y=rest[i*3+1],z=rest[i*3+2],cx=Math.floor(x/cell),cy=Math.floor(y/cell),cz=Math.floor(z/cell),list=[];
      for(let a=-1;a<=1;a++)for(let b=-1;b<=1;b++)for(let c=-1;c<=1;c++)for(const j of grid.get(key(cx+a,cy+b,cz+c))??[]){
        if(j!==i&&Math.hypot(rest[j*3]-x,rest[j*3+1]-y,rest[j*3+2]-z)<reach)list.push(j);
      }
      lists.push(list);
    }
    this.start=new Int32Array(n+1);for(let i=0;i<n;i++)this.start[i+1]=this.start[i]+lists[i].length;
    this.neighbours=Int32Array.from(lists.flat());
  }
  get mean(){let s=0;for(const v of this.warmth)s+=v;return this.warmth.length?s/this.warmth.length:0;}
  heat(point,dt,rate=10){
    const p=this.rest,R=this.radius*.2,r2=R*R;
    for(let i=0;i<this.warmth.length;i++){
      const d2=(p[i*3]-point[0])**2+(p[i*3+1]-point[1])**2+(p[i*3+2]-point[2])**2;
      if(d2<r2*4)this.warmth[i]+=(1-this.warmth[i])*Math.min(1,dt*rate*Math.exp(-d2/(r2*.5)));
    }
  }
  heatAll(dt,rate=1.2){for(let i=0;i<this.warmth.length;i++)this.warmth[i]+=(1-this.warmth[i])*Math.min(1,dt*rate);}
  step(dt){
    const w=this.warmth,next=this.scratch,steps=Math.max(1,Math.ceil(dt*this.spread/.5)),h=dt/steps;
    for(let s=0;s<steps;s++){
      for(let i=0;i<w.length;i++){
        const a=this.start[i],b=this.start[i+1];let sum=0;
        for(let k=a;k<b;k++)sum+=w[this.neighbours[k]];
        const average=b>a?sum/(b-a):w[i];
        next[i]=Math.min(1,Math.max(0,(w[i]+h*this.spread*(average-w[i]))*(1-h*this.cool)));
      }
      w.set(next);
    }
  }
}
